// Exercise `instructions` is an HTML field — the exercise-catalog seed writes
// <ul><li> and the coaching portal editor (parts/inputs/rich-text-input) adds
// <strong>/<u>/<br>. Places that render it as text rather than markup (tooltip
// contents, table cells, previews) show raw tags unless the HTML is flattened
// first.
//
// Legacy plain-text values pass through untouched.

const HTML_TAG_RE = /<[a-z/][^>]*>/i;

const ENTITIES = {
  "&nbsp;": " ",
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'",
  "&apos;": "'",
};

/**
 * Flattens HTML to readable plain text: list items become "• " bullets and
 * block boundaries become newlines. Render the result somewhere that keeps
 * newlines (`white-space: pre-line`) or they collapse to spaces.
 *
 * @param {unknown} value — HTML string, plain text, or null/undefined
 * @returns {string}
 */
export function htmlToPlainText(value) {
  if (!value || typeof value !== "string") return "";
  if (!HTML_TAG_RE.test(value)) return value;

  return (
    value
      .replace(/<li[^>]*>/gi, "\n• ")
      .replace(/<\/(?:p|div|li|ul|ol|h[1-6])\s*>/gi, "\n")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<[^>]+>/g, "")
      // One pass over the entities, so a literal "&amp;lt;" decodes to "&lt;"
      // instead of being decoded twice down to "<".
      .replace(
        /&nbsp;|&amp;|&lt;|&gt;|&quot;|&#39;|&apos;/gi,
        (match) => ENTITIES[match.toLowerCase()] ?? match
      )
      .replace(/[ \t]+/g, " ")
      .replace(/ *\n+ */g, "\n")
      .trim()
  );
}
